import React from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";

const DeleteDialog = ({ dialog, setDialog, handleDelete, title }) => {
  const intl = useIntl();

  return (
    <Modal show={dialog} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Delete {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to delete this {title} ?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={() => setDialog(false)}
            className="btn btn-light btn-elevate"
          >
            {intl.formatMessage({ id: "No" })}
          </button>
          <> </>
          <button
            type="button"
            onClick={handleDelete}
            className="btn btn-delete btn-elevate"
          >
            {intl.formatMessage({ id: "Yes" })}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteDialog;
